import { connect } from "react-redux";
import ApprovalPmTicket from "./approvalPmTicket";
import { bindActionCreators } from "redux";
import {fetchPmTicket,postUpdatePMStatus, getPmTicketsFilterDropDown} from "services/redux/maintenance/pmTicket/action";

const mapStateToProps = (state) => ({
    pmTicket: state.pmTicketReducer.pmTicket,
    pmTicketFilter: state.pmTicketReducer.pmTicketFilter,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        fetchPmTicket,
        postUpdatePMStatus,
        getPmTicketsFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalPmTicket);
